import type { Registry as Services } from '@ember/service';

export interface AccessFlags {
  features: string[];
  hasRates: boolean;
}

// Mirrors TabService#hasFeatureForNavigation: under unified hotel view a
// feature counts as available when any of the property's subscriptions grants
// it, not only the one the user is currently in.
function collectFeaturesAcrossSubscriptions(
  navigation: Services['navigation'],
): string[] {
  const features = new Set<string>();

  for (const subscriptionFeatures of navigation.subscriptionToFeatures.values()) {
    for (const feature of subscriptionFeatures) {
      features.add(feature);
    }
  }

  return Array.from(features);
}

export default function createAccessFlags(
  access: Services['access'],
  navigation: Services['navigation'],
): AccessFlags {
  if (!navigation.hasUnifiedHotelView) {
    return {
      features: Array.from(access.featureFlags),
      hasRates: access.hasRates,
    };
  }

  const features = collectFeaturesAcrossSubscriptions(navigation);

  return {
    features,
    hasRates: features.includes('app.rates'),
  };
}
